export default "__VITE_ASSET__bfff19b2__"